document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".routines__collection-tab");
  const dropdown = document.querySelector(".routines__collection-dropdown");
  const routines = document.querySelectorAll(".routine-row");

  function showRoutine(id) {
    routines.forEach(routine => {
      routine.style.display = routine.dataset.collection === id ? "flex" : "none";
    });

    if (dropdown) {
      dropdown.value = id;
    }

    tabs.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.collection === id);
    });
  }

  if (routines.length) {
    showRoutine(routines[0].dataset.collection);
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      showRoutine(tab.dataset.collection);
    });
  });

  if (dropdown) {
    dropdown.addEventListener("change", e => {
      showRoutine(e.target.value);
    });
  }
});